import CharlesMoundDates from "../../../../src/components/CharlesMoundDates";
import * as React from 'react';
export default {
  CharlesMoundDates,
  React
};